import { useQuery } from "@tanstack/react-query";
import api from "./requests";

// export function GetProgramByInstitute(id: number) {
//   const query = useQuery({
//     queryKey: [`GetProgramByInstitute`, id],
//     queryFn: async () => await api.getProgramByInstitute(id),
//     enabled: id > 0 && id !== undefined,
//   });

//   return query;
// }

export function GetProgrambyCommunity() {
  const query = useQuery({
    queryKey: [`getProgrambyCommunity`],
    queryFn: async () => await api.getProgrambyCommunity(),
    // enabled: id > 0 && id !== undefined,
  });

  return query;
}

export function GetBatchByProgramID(id: number) {
  const query = useQuery({
    queryKey: [`GetBatchByProgramID`, id],
    queryFn: async () => await api.getBatchByProgramID(id),
    enabled: id > 0 && id !== undefined,
  });

  return query;
}

// export function GetCourseRoleValues(id: number | undefined) {
//   const query = useQuery({
//     queryKey: [`GetCourseValues`, id],
//     queryFn: async () => await api.getCourseRoleValues(id),
//     refetchOnMount: false,
//     staleTime: 60000,
//     enabled: id !== undefined
//   });

//   return query;
// }

// export function GetSpecializationRoleValue(model: SpecializationModelForDropdown | undefined) {
//   const query = useQuery({
//     queryKey: [`getSpecializationRoleValue`, model],
//     queryFn: async () => await api.getSpecializationRoleValue(model),
//     enabled: model !== undefined && model.courseID > 0 && model.instituteID > 0
//   });

//   return query;
// }

// export function GetBatchRole(model: BatchModelForDropdown | undefined) {
//   const query = useQuery({
//     queryKey: [`getBatchRoleClient`, model],
//     queryFn: async () => await api.getBatchRole(model),
//     enabled: model !== undefined && model.courseID > 0 && model.instituteID > 0 && model.specializationID > 0
//   });

//   return query;
// }